import { AlertCircle, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { NETWORK_DOWN_MESSAGE, isNetworkError } from "@/lib/api";

interface QueryErrorProps {
  message?: string;
  error?: unknown;
  onRetry?: () => void;
  className?: string;
}

export function QueryError({
  message = "Something went wrong",
  error,
  onRetry,
  className,
}: QueryErrorProps) {
  const offline = isNetworkError(error);
  const displayMessage = offline ? NETWORK_DOWN_MESSAGE : message;
  const Icon = offline ? WifiOff : AlertCircle;

  return (
    <div
      className={cn(
        "rounded-lg border border-destructive/20 bg-destructive/5 p-6 text-center",
        className
      )}
    >
      <Icon className="mx-auto size-8 text-destructive/70" />
      <p className="mt-2 text-sm text-destructive">{displayMessage}</p>
      {onRetry && (
        <Button
          variant="outline"
          size="sm"
          className="mt-3 cursor-pointer"
          onClick={onRetry}
        >
          Try again
        </Button>
      )}
    </div>
  );
}
